import { render, staticRenderFns } from "./OrderProductCollapsableItem.vue?vue&type=template&id=feef16c4&"
import script from "./OrderProductCollapsableItem.vue?vue&type=script&lang=js&"
export * from "./OrderProductCollapsableItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports